export const getPageItems = (totalPages: number, currentPage: number) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, idx) => idx + 1)
  }

  // Note: left-ellipsis and right-ellipsis are used to indicate that there are more pages than can be displayed in the UI
  const items: Array<number | 'left-ellipsis' | 'right-ellipsis'> = [1]

  if (currentPage <= 4) {
    items.push(2)
  } else {
    items.push('left-ellipsis')
  }

  const centerStart = Math.max(3, Math.min(currentPage - 1, totalPages - 4))
  items.push(centerStart, centerStart + 1, centerStart + 2)

  if (currentPage >= totalPages - 3) {
    items.push(totalPages - 1)
  } else {
    items.push('right-ellipsis')
  }

  items.push(totalPages)

  return items
}
